module.exports = __webpack_public_path__ + "assets/img/IMG016.e0e704c7.png";